@import 'src/global/media_queries'
  
:host 
  display: block
  padding: 0.5rem 0

.heading 
  padding: 0.5rem 0

  @include media(">=tablet")
    padding: 0

.flex-wrapper
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  flex-wrap: wrap

  @include media(">=phoneXL")
    flex-direction: row

  div
    margin: 0.5rem
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

    @include media(">=phoneXL")
      margin: 1rem
